"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initTestStore = initTestStore;
exports.setStore = setStore;
exports.setDispatch = setDispatch;
exports.rewireObjectsAsAtoms = rewireObjectsAsAtoms;
exports.getAccountsForAtom = getAccountsForAtom;
exports.getEventsForAtom = getEventsForAtom;
exports.ATOM_DISPATCH_KEY = exports.getStore = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _dispatch;

var store = {};

function initTestStore(testStore) {
  store = testStore;
  return store;
}

function setStore(newStore) {
  store = newStore;
  return store;
}

var getStore = function getStore() {
  return store;
}; // default : (idx, atom, values) => { id : atom.id, idx, value : atom.default}
// atom : (idx, atom, values) => atom,
// value:(idx, atom, value, values) => value,


exports.getStore = getStore;
var ATOM_DISPATCH_KEY = {
  rewireObjectsAsAtoms: "rewireObjectsAsAtoms",
  getAccountsForAtom: "getAccountsForAtom",
  getEventsForAtom: "getEventsForAtom"
};
exports.ATOM_DISPATCH_KEY = ATOM_DISPATCH_KEY;

function sortedDebtinatorObjects(input) {
  if (Array.isArray(input)) {
    return input;
  } else {
    return Object.values(input).sort(function (a, b) {
      return a.name.localeCompare(b.name);
    });
  }
}

var dispatch = (_dispatch = {}, (0, _defineProperty2.default)(_dispatch, ATOM_DISPATCH_KEY.rewireObjectsAsAtoms, function () {
  var objects = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return sortedDebtinatorObjects(objects).map(function (obj) {
    return {
      value: obj.id,
      label: obj.name
    };
  });
}), (0, _defineProperty2.default)(_dispatch, ATOM_DISPATCH_KEY.getAccountsForAtom, function (idx) {
  var atom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var accounts = rewireObjectsAsAtoms(store.getState().accounts);
  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, atom), {}, {
    options: accounts,
    default: accounts[0].value
  });
}), (0, _defineProperty2.default)(_dispatch, ATOM_DISPATCH_KEY.getEventsForAtom, function (idx) {
  var atom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var events = rewireObjectsAsAtoms(store.getState().events);
  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, atom), {}, {
    options: events,
    default: events[0].value
  });
}), _dispatch);

function setDispatch(key, func) {
  dispatch[key] = func;
}

function rewireObjectsAsAtoms() {
  var objects = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return dispatch.rewireObjectsAsAtoms(objects);
}

function getAccountsForAtom(idx, atom, values) {
  return dispatch.getAccountsForAtom(idx, atom, values);
}

function getEventsForAtom(idx, atom, values) {
  return dispatch.getEventsForAtom(idx, atom, values);
}